export default "__VITE_ASSET__CnjvzU6$__"